module.exports = __webpack_public_path__ + "img/contentEcology.266c22a1.png";